import * as yup from 'yup';

import i18n from '@app/i18n/config';

import { firstNameSchema } from '@entities/fio-fields';

import { phoneRegEx } from '@shared/index';

import { validatePassword } from '../../lib';

export const registrationSchema = yup
  .object()
  .shape({
    phone: yup
      .string()
      .required(i18n.t('COMMON:errors.required'))
      .matches(phoneRegEx, i18n.t('COMMON:errors.incorrectPhoneNumber')),
    nickname: firstNameSchema,
  })
  .required();

export const createPasswordSchema = yup
  .object()
  .shape({
    password: yup
      .string()
      .required(i18n.t('COMMON:errors.required'))
      .min(12, '')
      .max(20, '')
      .test('isPasswordValid', '', (value) => validatePassword(value)),
    confirmPassword: yup
      .string()
      .required(i18n.t('COMMON:errors.required'))
      .oneOf([yup.ref('password')], ''),
  })
  .required();
